import { activeIcon } from "@pentacode/ui/components";
import { LitElement, css, html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { canAccess, menuItemState } from "../../lib/route-tree";
import { Routing, routeProperty } from "../../mixins/routing";
import { StateMixin } from "../../mixins/state";
import { shared } from "../../styles";
import { type ReportsPage, reportsPages, reportsRoute } from "../app-routes";
import { routeAccess } from "../route-access";
import "./costs";
import "./overview";
import "./revenue";
import "./savings";
import "./time";

@customElement("ptc-reports")
export class Reports extends Routing(StateMixin(LitElement)) {
    routePattern = /^reports(?:\/(?<page>\w+))?/;

    get helpPage() {
        switch (this._page) {
            case "overview":
                return "/handbuch/berichte/berichtsuebersicht/";
            case "savings":
                return "/handbuch/berichte/ersparnisberichte";
            case "time":
                return "/handbuch/berichte/arbeitszeitberichte";
            case "costs":
                return "/handbuch/berichte/personalkostenberichte";
            case "revenue":
                return "/handbuch/berichte/umsatzberichte";
            default:
                return "/handbuch/berichte";
        }
    }

    @routeProperty({ arg: "page" })
    private _page: ReportsPage;

    handleRoute() {
        if (!reportsPages.includes(this._page) || !this._canAccessPage(this._page)) {
            this.go(`reports/overview`, undefined, true);
            return;
        }
    }

    private _canAccessPage(page: ReportsPage) {
        return canAccess(reportsRoute(page), routeAccess());
    }

    static styles = [
        shared,
        css`
            :host {
                display: flex;
            }

            .sub-menu {
                width: 10em;
            }

            .main {
                flex: 1;
                position: relative;
            }
        `,
    ];

    private _renderButton(page: ReportsPage) {
        const route = reportsRoute(page);
        const state = menuItemState(route, routeAccess());
        if (state === "hidden") {
            return nothing;
        }

        const active = this._page === page;
        return html`
            <button ?active=${active} @click=${() => this.go(`reports/${page}`)} ?disabled=${state === "disabled"}>
                ${route.icon ? html`<ptc-ui-icon name=${activeIcon(route.icon, active)}></ptc-ui-icon>` : nothing}
                ${route.label}
            </button>
        `;
    }

    render() {
        return html`
            <div class="sub-menu">
                <div class="vertical tabs">${reportsPages.map((page) => this._renderButton(page))}</div>
            </div>

            <div class="main">
                <ptc-reports-overview ?hidden=${this._page !== "overview"}></ptc-reports-overview>
                <ptc-reports-costs ?hidden=${this._page !== "costs"}></ptc-reports-costs>
                <ptc-reports-savings ?hidden=${this._page !== "savings"}></ptc-reports-savings>
                <ptc-reports-time ?hidden=${this._page !== "time"}></ptc-reports-time>
                <ptc-reports-revenue ?hidden=${this._page !== "revenue"}></ptc-reports-revenue>
            </div>
        `;
    }
}
